/* ToTopButtonComponent template */
import { FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PlaceholderIcons } from '@cewe-designsystem/util_placeholder_icons';
import { ToTopButtonComponent } from './cwc-to-top-button';

/**
 * Definition of  parameters that the template needs to work.
 */
interface ToTopButtonTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: ToTopButtonComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const ToTopButtonTemplate: FunctionalComponent<ToTopButtonTemplateProps> = ({ controller }) => (
  <Host style={{ '--to-top-button-offset': controller.toTopButtonOffset + 'px' }}>
    <button
      class={'float-to-top-button'}
      aria-label={controller.label}
      style={!controller.isScrolled ? { display: 'none' } : {}}
      onClick={() => controller.scrollToTop()}
    >
      <svg viewBox="0 0 24 24">{PlaceholderIcons.svgArrowUp()}</svg>
    </button>
  </Host>
);

export default ToTopButtonTemplate;
